export default function parseQueryString (url = location.search) {
  return url.substr(1).split('&').reduce((accum, kv) => {
    const [key, value] = kv.split('=')
    accum[decodeURIComponent(key)] = (() => {
      switch (value) {
        case undefined:
          return true
        case '':
          return null
        default:
          return decodeURIComponent(value)
      }
    })()

    return accum
  }, {})
}

window.parseQueryString = parseQueryString
